import * as React from 'react';
import { t } from '@deltasierra/shared';
import CloudDownload from '@material-ui/icons/CloudDownload';
import Fullscreen from '@material-ui/icons/Fullscreen';
import Close from '@material-ui/icons/Close';
import Link from '@material-ui/icons/Link';
import { DSIconButton, Tooltip } from '../Generic';

export type LightboxModalDefaultButtonsProps = {
    onClose: () => void;
    onCopyUrl: () => void;
    onDownloadFile: () => void;
    onFullscreen: () => void;
    showCopyUrlButton: boolean;
};

export function LightboxModalDefaultButtons({
    onClose,
    onCopyUrl,
    onDownloadFile,
    onFullscreen,
    showCopyUrlButton,
}: LightboxModalDefaultButtonsProps): JSX.Element {
    return (
        <>
            {showCopyUrlButton && (
                <Tooltip placement="bottom" tip={t('ASSET_LIBRARY.COPY_ASSET_URL')}>
                    <span>
                        <DSIconButton style={{ color: 'white' }} onClick={onCopyUrl}>
                            <Link style={{ height: '2rem', margin: '12px', width: '2rem' }} />
                        </DSIconButton>
                    </span>
                </Tooltip>
            )}
            <Tooltip placement="bottom" tip={t('COMMON.DOWNLOAD')}>
                <span>
                    <DSIconButton style={{ color: 'white' }} onClick={onDownloadFile}>
                        <CloudDownload style={{ height: '2rem', margin: '12px', width: '2rem' }} />
                    </DSIconButton>
                </span>
            </Tooltip>
            <Tooltip placement="bottom" tip={t('COMMON.FULL_SCREEN')}>
                <span>
                    <DSIconButton style={{ color: 'white' }} onClick={onFullscreen}>
                        <Fullscreen style={{ height: '2rem', margin: '12px', width: '2rem' }} />
                    </DSIconButton>
                </span>
            </Tooltip>
            <Tooltip placement="bottom" tip={t('COMMON.CLOSE')}>
                <span>
                    <DSIconButton style={{ color: 'white' }} onClick={onClose}>
                        <Close style={{ height: '2rem', margin: '12px', width: '2rem' }} />
                    </DSIconButton>
                </span>
            </Tooltip>
        </>
    );
}
LightboxModalDefaultButtons.displayName = 'LightboxModalDefaultButtons';
